import React, { useState } from "react";
import "./Sidebar.css";
import kickLogo from "../assets/kick.svg";
import twitchLogo from "../assets/twitch.png";
import logo from "../assets/logo.gif";
import logo2 from "../assets/logo2.gif";

const Sidebar = ({
  onMenuClick,
  featuredVideos = [],
  onVideoSelect,
  selectedVideoId,
  selectedPlatform,
  setSelectedPlatform,
  kickSortOrder,
  setKickSortOrder,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleLogoClick = () => onMenuClick();

  return (
    <>
      <div
        className="sidebar-hover-area"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      ></div>

      <div
        className={`sidebar ${isHovered ? "sidebar-open" : ""} ${selectedPlatform}-theme`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="sidebar-header">
          <button 
            className="sidebar-back-button"
            onClick={handleLogoClick}
            title="Ana Menüye Dön"
          >
            ←
          </button>
          <div className="sidebar-header-top">
            <div className="platform-buttons-sidebar left">
              <button
                className={selectedPlatform === "kick" ? "active" : ""}
                onClick={() => setSelectedPlatform("kick")}
                title="Kick"
              >
                <img src={kickLogo} alt="Kick" className="platform-icon" />
              </button>
            </div>

            <div className="sidebar-logo-container">
              <img
                src={selectedPlatform === "twitch" ? logo2 : logo}
                alt="Logo"
                className="sidebar-logo"
                onClick={handleLogoClick}
              />
            </div>

            <div className="platform-buttons-sidebar right">
              <button
                className={selectedPlatform === "twitch" ? "active" : ""}
                onClick={() => setSelectedPlatform("twitch")}
                title="Twitch"
              >
                <img src={twitchLogo} alt="Twitch" className="platform-icon" />
              </button>
            </div>
          </div>
          
        </div>

        {/* Sidebar body ... */}



        {/* Scrollable video listesi */}
        <div className="sidebar-body">
          <ul className="sidebar-video-list">
            {featuredVideos.map((video) => (
              <li
                key={video.videoId}
                className={`sidebar-video ${
                  video.videoId === selectedVideoId ? "selected-video" : ""
                }`}
                onClick={() => {
                  if (onVideoSelect) onVideoSelect(video.videoId);
                }}
              >
                <img
                  src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
                  alt={video.title}
                  className="sidebar-thumbnail"
                />
                <div className="sidebar-video-text">
                  <div className="sidebar-video-title">{video.title}</div>
                  <div className="sidebar-video-date">{video.date}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
